import React from 'react';

// 客戶要求所有提醒一律由使用者按 X 自行關閉，不再有任何自動關閉計時器（RENT-34）。
const Toast = ({ toast, onClose }) => {
  return (
    <div className={`toast toast-${toast.type}`} role="alert">
      <div className="toast-content">
        {toast.type === 'success' && <span className="toast-icon success-icon">✓</span>}
        {toast.type === 'error' && <span className="toast-icon error-icon">✗</span>}
        {toast.type === 'info' && <span className="toast-icon info-icon">ℹ</span>}
        {toast.type === 'warning' && <span className="toast-icon warning-icon">⚠</span>}
        <span className="toast-message">{toast.message}</span>
      </div>
      <button
        type="button"
        className="toast-close"
        onClick={onClose}
        aria-label="關閉這則提醒"
        title="關閉這則提醒"
      >
        ×
      </button>
    </div>
  );
};

export default Toast;
